import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { dialogProviderInjectionKey as N } from "../../dialog/src/context.js";
import x from "./BodyWrapper.js";
import { modalProviderInjectionKey as L, modalInjectionKey as H } from "./interface.js";
import { presetProps as D, presetPropsKeys as z } from "./presetProps.js";
import I from "./styles/index.cssr.js";
import { warnOnce as f } from "../../_utils/naive/warn.js";
import T from "../../_mixins/use-config.js";
import y from "../../_mixins/use-theme.js";
import U from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-clicked.js";
import _ from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-click-position.js";
import K from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/life-cycle/use-is-mounted.js";
import { useIsComposing as V } from "../../_utils/composable/use-is-composing.js";
import { useThemeClass as $ } from "../../_mixins/use-css-vars-class.js";
import { keep as W } from "../../_utils/vue/keep.js";
import q from "../../../../../../vdirs@0.1.8_vue@3.5.18/node_modules/vdirs/es/zindexable/index.js";
import G from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/lazy-teleport/src/index.js";
import J from "../styles/light.js";
import { call as u } from "../../_utils/vue/call.js";
import { getPreciseEventTarget as Q } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/dom/get-precise-event-target.js";
import { eventEffectNotPerformed as X } from "../../_utils/event/index.js";
import { defineComponent as Y, inject as k, provide as Z, computed as C, h as d, withDirectives as ee } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as oe, toRef as g } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { Transition as te } from "../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
const ne = Object.assign(Object.assign(Object.assign(Object.assign({}, y.props), {
  show: Boolean,
  unstableShowMask: {
    type: Boolean,
    default: !0
  },
  maskClosable: {
    type: Boolean,
    default: !0
  },
  preset: String,
  to: [String, Object],
  displayDirective: {
    type: String,
    default: "if"
  },
  transformOrigin: {
    type: String,
    default: "mouse"
  },
  zIndex: Number,
  autoFocus: {
    type: Boolean,
    default: !0
  },
  trapFocus: {
    type: Boolean,
    default: !0
  },
  closeOnEsc: {
    type: Boolean,
    default: !0
  },
  blockScroll: {
    type: Boolean,
    default: !0
  }
}), D), {
  draggable: [Boolean, Object],
  // events
  onEsc: Function,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onAfterEnter: Function,
  onBeforeLeave: Function,
  onAfterLeave: Function,
  onClose: Function,
  onPositiveClick: Function,
  onNegativeClick: Function,
  onMaskClick: Function,
  // private
  internalDialog: Boolean,
  internalModal: Boolean,
  internalAppear: {
    type: Boolean,
    default: void 0
  },
  // deprecated
  overlayStyle: [String, Object],
  onBeforeHide: Function,
  onAfterHide: Function,
  onHide: Function
}), Ae = Y({
  name: "Modal",
  inheritAttrs: !1,
  props: ne,
  slots: Object,
  setup(o) {
    process.env.NODE_ENV !== "production" && (o.onHide && f("modal", "`on-hide` is deprecated."), o.onAfterHide && f("modal", "`on-after-hide` is deprecated, please use `on-after-leave` instead."), o.onBeforeHide && f("modal", "`on-before-hide` is deprecated, please use `on-before-leave` instead."), o.overlayStyle && f("modal", "`overlay-style` is deprecated, please use `style` instead."));
    const s = oe(null), {
      mergedClsPrefixRef: a,
      namespaceRef: l,
      inlineThemeDisabled: m
    } = T(o), h = y("Modal", "-modal", I, J, o, a), b = U(64), P = _(), v = K(), B = o.internalDialog ? k(N, null) : null, R = o.internalModal ? k(L, null) : null, F = V();
    function i(e) {
      const {
        onUpdateShow: t,
        "onUpdate:show": n,
        onHide: c
      } = o;
      t && u(t, e), n && u(n, e), c && !e && c(e);
    }
    function S() {
      const {
        onClose: e
      } = o;
      e ? Promise.resolve(e()).then((t) => {
        t !== !1 && i(!1);
      }) : i(!1);
    }
    function w() {
      const {
        onPositiveClick: e
      } = o;
      e ? Promise.resolve(e()).then((t) => {
        t !== !1 && i(!1);
      }) : i(!1);
    }
    function A() {
      const {
        onNegativeClick: e
      } = o;
      e ? Promise.resolve(e()).then((t) => {
        t !== !1 && i(!1);
      }) : i(!1);
    }
    function M() {
      const {
        onBeforeLeave: e,
        onBeforeHide: t
      } = o;
      e && u(e), t && t();
    }
    function O() {
      const {
        onAfterLeave: e,
        onAfterHide: t
      } = o;
      e && u(e), t && t();
    }
    function E(e) {
      var t;
      const {
        onMaskClick: n
      } = o;
      n && n(e), o.maskClosable && !((t = s.value) === null || t === void 0) && t.contains(Q(e)) && i(!1);
    }
    function j(e) {
      var t;
      (t = o.onEsc) === null || t === void 0 || t.call(o), o.show && o.closeOnEsc && X(e) && (F.value || i(!1));
    }
    Z(H, {
      getMousePosition: () => {
        const e = B || R;
        if (e) {
          const {
            clickedRef: t,
            clickedPositionRef: n
          } = e;
          if (t.value && n.value)
            return n.value;
        }
        return b.value ? P.value : null;
      },
      mergedClsPrefixRef: a,
      mergedThemeRef: h,
      isMountedRef: v,
      appearRef: g(o, "internalAppear"),
      transformOriginRef: g(o, "transformOrigin")
    });
    const p = C(() => {
      const {
        common: {
          cubicBezierEaseOut: e
        },
        self: {
          boxShadow: t,
          color: n,
          textColor: c
        }
      } = h.value;
      return {
        "--n-bezier-ease-out": e,
        "--n-box-shadow": t,
        "--n-color": n,
        "--n-text-color": c
      };
    }), r = m ? $("theme-class", void 0, p, o) : void 0;
    return {
      mergedClsPrefix: a,
      namespace: l,
      isMounted: v,
      containerRef: s,
      presetProps: C(() => W(o, z)),
      handleEsc: j,
      handleAfterLeave: O,
      handleClickoutside: E,
      handleBeforeLeave: M,
      doUpdateShow: i,
      handleNegativeClick: A,
      handlePositiveClick: w,
      handleCloseClick: S,
      cssVars: m ? void 0 : p,
      themeClass: r == null ? void 0 : r.themeClass,
      onRender: r == null ? void 0 : r.onRender
    };
  },
  render() {
    const {
      mergedClsPrefix: o
    } = this;
    return d(G, {
      to: this.to,
      show: this.show
    }, {
      default: () => {
        var s;
        (s = this.onRender) === null || s === void 0 || s.call(this);
        const {
          unstableShowMask: a
        } = this;
        return ee(d("div", {
          role: "none",
          ref: "containerRef",
          class: [`${o}-modal-container`, this.themeClass, this.namespace],
          style: this.cssVars
        }, d(x, Object.assign({
          style: this.overlayStyle
        }, this.$attrs, {
          ref: "bodyWrapper",
          displayDirective: this.displayDirective,
          show: this.show,
          preset: this.preset,
          autoFocus: this.autoFocus,
          trapFocus: this.trapFocus,
          draggable: this.draggable,
          blockScroll: this.blockScroll
        }, this.presetProps, {
          onEsc: this.handleEsc,
          onClose: this.handleCloseClick,
          onNegativeClick: this.handleNegativeClick,
          onPositiveClick: this.handlePositiveClick,
          onBeforeLeave: this.handleBeforeLeave,
          onAfterEnter: this.onAfterEnter,
          onAfterLeave: this.handleAfterLeave,
          onClickoutside: a ? void 0 : this.handleClickoutside,
          renderMask: a ? () => {
            var l;
            return d(te, {
              name: "fade-in-transition",
              key: "mask",
              appear: (l = this.internalAppear) !== null && l !== void 0 ? l : this.isMounted
            }, {
              default: () => this.show ? d("div", {
                "aria-hidden": !0,
                ref: "containerRef",
                class: `${o}-modal-mask`,
                onClick: this.handleClickoutside
              }) : null
            });
          } : void 0
        }), this.$slots)), [[q, {
          zIndex: this.zIndex,
          enabled: this.show
        }]]);
      }
    });
  }
});
export {
  Ae as default,
  ne as modalProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/modal/src/Modal.js
// module id = 22
// module chunks = 67